var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyChallenge = function SvgEmptyChallenge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "28.222%",
    x2: "100%",
    y2: "28.222%",
    id: "emptyChallenge_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-101.056%",
    y1: "109.114%",
    x2: "101.058%",
    y2: "109.114%",
    id: "emptyChallenge_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.027%",
    x2: "100%",
    y2: "50.027%",
    id: "emptyChallenge_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA3BE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyChallenge_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "36.157%",
    x2: "51.999%",
    y2: "53.791%",
    id: "emptyChallenge_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADC2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACC0D5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.291%",
    y1: "0%",
    x2: "50.537%",
    y2: "63.692%",
    id: "emptyChallenge_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.068%",
    y1: "0%",
    x2: "50.607%",
    y2: "63.692%",
    id: "emptyChallenge_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.986%",
    y1: "0%",
    x2: "51.89%",
    y2: "63.692%",
    id: "emptyChallenge_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "32.973%",
    x2: "51.999%",
    y2: "54.663%",
    id: "emptyChallenge_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.66 5.956H7.737c-2.001 0-3.623 1.707-3.623 3.812v7.625h55.548V5.956Z",
    fill: "url(#emptyChallenge_svg__a)",
    transform: "translate(0 11.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.66 3.812C59.66 1.707 58.04 0 56.039 0H37.105C35.37 0 33.77.977 32.91 2.56l-3.44 6.335h30.19V3.812Z",
    fill: "url(#emptyChallenge_svg__b)",
    transform: "translate(0 11.093)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyChallenge_svg__c)",
    d: "M4.113 9.528h55.548v2.368H4.113z",
    transform: "translate(0 11.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.728 17.22a5.269 5.269 0 0 0-1.142-4.037c-.918-1.108-2.246-1.745-3.643-1.746H4.83c-1.397 0-2.725.637-3.643 1.745a5.266 5.266 0 0 0-1.14 4.038l4.695 35.582c.332 2.513 2.374 4.383 4.785 4.383h44.72c2.41 0 4.452-1.87 4.784-4.383l4.697-35.582Z",
    fill: "url(#emptyChallenge_svg__d)",
    transform: "translate(0 11.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.452 31.033c.224-2.62 2.31-4.629 4.81-4.63h53.249c2.501-.001 4.589 2.008 4.81 4.63l.407-3.075a5.269 5.269 0 0 0-1.142-4.037c-.918-1.109-2.246-1.746-3.643-1.747H4.83c-1.397 0-2.725.637-3.643 1.746a5.266 5.266 0 0 0-1.14 4.038l.405 3.075Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2C3",
    d: "m29.399 26.342 3.625-4.168h8.772l-3.012 4.168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.624 44.154c0-1.403-1.081-2.541-2.415-2.541h-9.66c-1.335 0-2.416 1.138-2.416 2.541v2.542c0 1.404 1.081 2.542 2.415 2.542h9.66c1.335 0 2.416-1.138 2.416-2.542v-2.542ZM55.435 44.154c0-1.403-1.08-2.541-2.415-2.541h-9.66c-1.334 0-2.415 1.138-2.415 2.541v2.542c0 1.404 1.081 2.542 2.415 2.542h9.66c1.334 0 2.415-1.138 2.415-2.542v-2.542Z",
    fill: "url(#emptyChallenge_svg__e)",
    transform: "translate(0 11.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87 0 0 19.687h11.594L3.347 41.936l18.389-28.087h-9.903L18.256 0z",
    transform: "translate(20.528 26.342)",
    fill: "url(#emptyChallenge_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.888 1.572.636 2.438a.816.816 0 0 0 1.001.594.844.844 0 0 0 .578-1.03l-.635-2.436a.83.83 0 0 0-.578-.599.802.802 0 0 0-.792.218.858.858 0 0 0-.21.815Z",
    fill: "url(#emptyChallenge_svg__g)",
    transform: "rotate(58 29.808 53.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.375 1.435 4.187 4.307c.32.319.83.314 1.146-.01a.858.858 0 0 0 .01-1.18L2.53.247A.802.802 0 0 0 1.74.03a.83.83 0 0 0-.578.594c-.075.29.005.6.212.812Z",
    fill: "url(#emptyChallenge_svg__h)",
    transform: "rotate(58 29.808 53.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.606 9.787 2.37.653a.816.816 0 0 0 .997-.596.844.844 0 0 0-.575-1.028L1.03 8.162a.816.816 0 0 0-1.002.595.844.844 0 0 0 .578 1.03Z",
    fill: "url(#emptyChallenge_svg__i)",
    transform: "rotate(58 29.808 53.776)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.052,
    fill: "#000",
    opacity: 0.59,
    cx: 32.995,
    cy: 78.28,
    rx: 17.322,
    ry: 1.667
  }))));
};
export default SvgEmptyChallenge;